import { MoreVertical } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { ICartaoView } from "shared/interfaces/IMetodo";
import styles from "./MetodoItem.module.scss";

const bandeiraMap: Record<string, { nome: string; logo: string }> = {
  visa: { nome: "Visa", logo: "/imagens/cartoes/visa.png" },
  mastercard: {
    nome: "Mastercard",
    logo: "/imagens/cartoes/mastercard.png",
  },
  amex: {
    nome: "American Express",
    logo: "/imagens/cartoes/amex.png",
  },
  elo: { nome: "Elo", logo: "/imagens/cartoes/elo.png" },
};

interface Props {
  cartao?: ICartaoView | null;
  selecionado: boolean;
  onClick: () => void;

  onExcluir?: (id: string) => void;
  onDefinirPrincipal?: (id: string) => void;
}

export const MetodoItem: React.FC<Props> = ({
  cartao,
  selecionado,
  onClick,
  onExcluir,
  onDefinirPrincipal,
}) => {
  const [openMenu, setOpenMenu] = useState(false);

  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setOpenMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () =>
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
  }, []);

  const bandeira = bandeiraMap[cartao?.marca ?? ""];

  const logoSrc =
    cartao?.bandeira ??
    bandeira?.logo ??
    "/imagens/cartoes/default.png";

  const nomeExibicao = bandeira?.nome ?? "Cartão";

  const finalCartao =
    cartao?.ultimos4digitos ?? "0000";

  return (
    <div
      className={styles.card}
      onClick={onClick}
    >
      <div className={styles.left}>
        <div className={styles.radio}>
          {selecionado && (
            <div className={styles.radioSelecionado} />
          )}
        </div>

        <div className={styles.info}>
          <h3>
            {nomeExibicao} **** {finalCartao}
          </h3>

          {cartao?.defaultCard && (
            <span>Cartão principal</span>
          )}
        </div>
      </div>

      <div
        className={styles.right}
        ref={menuRef}
      >
        <img
          src={logoSrc}
          alt={nomeExibicao}
          className={styles.bandeira}
        />

        <button
          className={styles.btnMenu}
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu((old) => !old);
          }}
        >
          <MoreVertical size={18} />
        </button>

        {openMenu && (
          <div className={styles.menu}>
            {!cartao?.defaultCard && (
              <button
                className={styles.menuItem}
                onClick={(e) => {
                  e.stopPropagation();

                  setOpenMenu(false);

                  onDefinirPrincipal?.(cartao!.id);
                }}
              >
                Definir como principal
              </button>
            )}

            <button
              className={`${styles.menuItem} ${styles.excluir}`}
              onClick={(e) => {
                e.stopPropagation();

                setOpenMenu(false);

                onExcluir?.(cartao!.id);
              }}
            >
              Excluir cartão
            </button>
          </div>
        )}
      </div>
    </div>
  );
};